<template>
    <vx-table class="xl:grid-cols-12-auto mb-8" rowBreakpoint="xl">
        <vx-table-row isHeader>
            <div class="lg:pl-6">Campaign ID</div>
            <div>Source</div>
            <div>Brand</div>
            <div>Brand Trust</div>
            <div>Use Case</div>
            <div>Status</div>
            <div>DCA Complete</div>
            <div>AT&T Class</div>
            <div>T-Mobile Tier</div>
            <div>Terms</div>
            <div>Numbers</div>
        </vx-table-row>

        <slot></slot>
    </vx-table>
</template>

<script lang="ts" setup>
import { VxTable, VxTableRow } from '@voxie/frontend-components';
</script>
